import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	stroke: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M3.138 8.195c-.26-.26-.682-.26-.943 0-.26.26-.26.683 0 .943l3.334 3.333c.26.26.682.26.942 0l7.334-7.333c.26-.26.26-.682 0-.943-.26-.26-.683-.26-.943 0L6 11.057 3.138 8.195z",
		transform: "translate(-1320 -664) translate(1072 520) translate(16 120) translate(224 16) translate(8 8)"
	})
});
export default SvgCheck;
